import React from "react";
import FaxIcon from "@mui/icons-material/Fax";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PlaceIcon from "@mui/icons-material/Place";
import PaymentIcon from "@mui/icons-material/Payment";
import { Link } from "react-router-dom";
export default function ContactForm() {
  return (
    <div className="flex justify-center items-center flex-col w-full md:pt-20 pt-14 xl:pt-48">
      <h1 className="lg:text-[52px] text-[28px] leading-[1.4em] xl:mb-20 text-[#f5f5f5] font-normal font-heading capitalize">
        Contact Us
      </h1>
      <div className="w-11/12 xl:w-4/5 3xl:w-3/5 md:my-16 my-8 grid grid-cols-1 lg:grid-cols-2 gap-10 font-robout">
        {/* LEFT SIDE */}

        <ul
          data-aos="fade-up"
          className="flex flex-col gap-5 justify-center lg:text-[24px] font-heading text-[18px] leading-[1.4em] text-[#cccccc] font-normal  text-xl md:text-left text-center"
        >
          <li className="flex flex-row gap-5 items-center text-xl hover:text-white hover:underline  justify-start   ">
            <LocalPhoneIcon className="text-[#bf9c5e]" />
            <a aria-label="call" href="tel:3527959200" title="Office">
              (352) 795-9200
            </a>
          </li>
          <li className="flex flex-row gap-5 items-center  text-xl hover:text-white hover:underline  justify-start   ">
            <PaymentIcon className=" text-[#bf9c5e]" />
            <a aria-label="Billling" href="tel:3524508052" title="Billing">
              (352) 450-8052
            </a>
          </li>

          <li className="flex flex-row gap-5 items-center text-xl hover:text-white hover:underline  justify-start">
            <FaxIcon className=" text-[#bf9c5e]" />
            <a
              aria-label="fax"
              href="fax:352-795-6460"
              title="Fax"
              onClick={(e) => {
                e.preventDefault();

                const faxNumber = "352-795-6460";

                // 1️⃣ Try opening fax
                window.location.href = "fax:3527956460";

                // 2️⃣ Always copy (guaranteed)
                navigator.clipboard.writeText(faxNumber);
              }}
            >
              (352) 795-6460
            </a>
          </li>

          <li className="flex flex-row gap-5 items-center text-xl hover:text-white hover:underline  justify-start ">
            <PlaceIcon className="text-[#bf9c5e]" />
            <Link
              to="https://maps.app.goo.gl/MQ5H5FsCB4nBt8dy7"
              target="_blank"
              aria-label="Address"
              title="visit"
            >
              922 North Citrus Avenue <br /> Crystal River, Florida 34428
            </Link>
          </li>
          <li className="flex flex-row gap-5 items-center text-xl  justify-start">
            <CalendarMonthIcon className=" text-[#bf9c5e]" />
            <span>Mon-Fri : 8:30am – 5pm</span>
          </li>
        </ul>

        {/* RIGHT SIDE */}
        <div className="flex justify-center items-start text-white ">
          <div data-aos="fade-up" className="text-left">
            <h3
              data-aos="fade-up"
              className=" lg:text-[28px] font-heading text-[20px] leading-[1.4em] text-[#cccccc] font-normal mb-4"
            >
              Appointment Confirmation & Cancellation Policy
            </h3>

            <p>
              To help us serve all our patients efficiently, a member of our
              staff will contact you by phone and/or text a few days prior to
              your appointment to confirm. If you need to cancel or reschedule,
              we kindly ask that you notify us at least 24 hours in advance.
            </p>
          </div>
        </div>
      </div>

      <div className="w-11/12 xl:w-4/5 3xl:w-3/5 md:my-16 my-8">
        {/* <iframe
          title="Citrus Diagnostic Center Florida"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6985.813095337112!2d-82.591563!3d28.901124999999997!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e841badd2a4091%3A0xeb4dead7dc4f5402!2sCitrus%20Diagnostic%20Center!5e0!3m2!1sen!2sin!4v1760678219616!5m2!1sen!2sin"
          className="w-full md:h-[450px] h-[300px]"
          height=""
          width="100%"
          allowFullScreen="true`"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe> */}
        <iframe
            src="https://maps.google.com/maps?q=28.901124,-82.591563&z=15&output=embed"
            className="w-full md:h-[450px] h-[300px]" title="citrus diagnostic center"
            loading="lazy"
          ></iframe>
      </div>
    </div>
  );
}
